<template>
    <div>
        <LabelContent title="基本信息" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="110px"
                     class="unitWidth" size="small">
                <el-form-item label="设备编号">
                    <el-input v-model.trim="devCode" placeholder="请输入设备编号(必填)"></el-input>
                </el-form-item>
                <el-form-item label="设备名">
                    <el-input v-model.trim="devName" placeholder="请输入设备名(必填)"></el-input>
                </el-form-item>
                <el-form-item label="设备状态">
                    <el-select v-model="devStatus" placeholder="请选择">
                        <el-option label="使用中" value="101"></el-option>
                        <el-option label="闲置中" value="102"></el-option>
                        <el-option label="报废中" value="103"></el-option>
                        <el-option label="移管中" value="104"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否关键设备">
                    <!--<el-select v-model="keyDevices" placeholder="请选择">
                        <el-option label="是" value="0"></el-option>
                        <el-option label="否" value="1"></el-option>
                    </el-select>-->
                    <el-switch
                        v-model="keyDevices"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="责任人工号">
                    <el-input v-model.trim="personNo" placeholder="请输入责任人工号(必填)"></el-input>
                </el-form-item>
                <el-form-item label="责任人">
                    <el-input v-model.trim="person" placeholder="请输入责任人(必填)"></el-input>
                </el-form-item>
                <el-form-item label="出厂年份">
                    <el-date-picker v-model="yearOfManu" type="date" placeholder="选择出厂年份(必填)"></el-date-picker>
                </el-form-item>
                <el-form-item label="进厂日期">
                    <el-date-picker v-model="dateOfArri" type="date" placeholder="选择进厂日期(必填)"></el-date-picker>
                </el-form-item>
                <el-form-item label="使用年限">
                    <el-input v-model.trim="serviceLife" placeholder="请输入使用年限(必填)"></el-input>
                </el-form-item>
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择工厂(必填)" :disabled="ischeck" :clearable="isclear"
                               filterable @change="fcChange">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择车间(必填)" clearable filterable @change="shopChange">
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择工段(必填)" clearable filterable
                               @change="sectionChange">
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择产线(必填)" clearable filterable @change="lineChange">
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备位置">
                    <el-input v-model.trim="note" placeholder="请输入设备位置"></el-input>
                </el-form-item>
                <el-form-item label="供应商">
                    <el-input v-model.trim="devSupplier" placeholder="请输入供应商"></el-input>
                </el-form-item>
                <el-form-item label="供应商联系方式">
                    <el-input v-model.trim="devSupConInf" placeholder="请输入供应商联系方式"></el-input>
                </el-form-item>
                <el-form-item label="供应商地址">
                    <el-input v-model.trim="devSupplierAddress" placeholder="请输入供应商地址"></el-input>
                </el-form-item>
                <el-form-item label="固定资产编码">
                    <el-input v-model.trim="assetsNo" placeholder="请输入固定资产编码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addDevice">确定</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="文件信息" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                <el-button type="primary" @click="addDeviceFile">上传文件</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="deviceFileList" class="center">
                <el-table-column prop="fileName" sortable label="文件名" show-overflow-tooltip/>
                <el-table-column prop="fileUrl" sortable label="文件路径" show-overflow-tooltip/>
                <el-table-column prop="fileType" sortable label="文件类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!--<span v-if="scope.row.fileType == 'main_man'">维护手册</span>
                        <span v-if="scope.row.fileType == 'main_pro'">检修规程</span>
                        <span v-if="scope.row.fileType == 'oper_doc'">作业文件</span>
                        <span v-if="scope.row.fileType == 'elec_dia'">电气图</span>
                        <span v-if="scope.row.fileType == 'mac_dra'">机加工图</span>
                        <span v-if="scope.row.fileType == 'equ_par'">设备参数</span>
                        <span v-if="scope.row.fileType == 'pro_list'">防错清单</span>
                        <span v-if="scope.row.fileType == 'other'">其他</span>-->
                        <span v-for="file in fileTypeList"
                              v-if="file.etCode == scope.row.fileType">{{file.etName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <i class="delBtn iconfont u-shanchu" @click="deleteDeviceFile(scope)"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="上传文件" width="500px" :visible.sync="addDeviceFileShow" style="text-align:left">
            <el-form :model="fileForm" :rules="filerules" ref="fileForm" label-width="100px" class="demo-roleForm">
                <el-form-item label="文件名" prop="fileName">
                    <el-input v-model.trim="fileForm.fileName" placeholder="请输入文件名"></el-input>
                </el-form-item>
                <el-form-item label="文件" prop="fileUrl">
                    <el-upload
                        v-show="fileUpload"
                        class="upload-demo"
                        :headers="{'X-Auth-Token':token}"
                        :action="URL"
                        :on-success="handleSuccess"
                        :on-remove="delImg"
                        :file-list="fileList"
                        :clearFiles="clearFiles"
                        :limit="1"
                        multiple>
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <el-input v-show="fileUrlShow" v-model="fileForm.fileUrl" disabled></el-input>
                </el-form-item>
                <el-form-item label="文件类型" prop="fileType">
                    <el-select v-model="fileForm.fileType" placeholder="请选择文件类型">
                        <!--<el-option label="维护手册" value="main_man"></el-option>
                        <el-option label="检修规程" value="main_pro"></el-option>
                        <el-option label="作业文件" value="oper_doc"></el-option>
                        <el-option label="电气图" value="elec_dia"></el-option>
                        <el-option label="机加工图" value="mac_dra"></el-option>
                        <el-option label="设备参数" value="equ_par"></el-option>
                        <el-option label="防错清单" value="pro_list"></el-option>
                        <el-option label="其他" value="other"></el-option>-->
                        <el-option
                            v-for="file in fileTypeList"
                            :key="file.etId"
                            :label="file.etName"
                            :value="file.etCode">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDeviceFileShow = false">取 消</el-button>
                <el-button type="primary" @click="add('fileForm')">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'addDevice',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                factoryTree: [],
                fileTypeList: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                devCode: '',
                devName: '',
                fcName: '',
                shopName: '',
                sectionName: '',
                lineName: '',
                devsRelative: '',
                note: '',
                devSupplier: '',
                devSupConInf: '',
                devSupplierAddress: '',
                assetsNo: '',
                deviceFileList: [],
                addDeviceFileShow: false,
                fileForm: {
                    fileName: '',
                    fileUrl: '',
                    fileType: ''
                },
                filerules: {
                    fileName: [
                        {
                            required: true,
                            message: '请输入文件名',
                            trigger: 'blur'
                        }
                    ],
                    fileUrl: [
                        {
                            required: true,
                            message: '请选择文件',
                            trigger: 'blur'
                        }
                    ],
                    fileType: [
                        {
                            required: true,
                            message: '请选择文件类型',
                            trigger: 'change'
                        }
                    ]
                },
                URL: '',
                token: '',
                fileList: [],
                clearFiles: '',
                yearOfManu: '',
                dateOfArri: '',
                serviceLife: '',
                devStatus: '',
                Status: '',
                empNo: '',
                person: '',
                keyDevices: false,
                personNo: '',
                fileUrlShow: false,
                fileUpload: true,
                ischeck: true,
                isclear: false,
                role: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.URL = 'https://tpm.joysonsafety.com.cn/api/upload/files'
            // this.URL = 'https://tpm.joysonsafety.com.cn/back/api/upload/files'
            // this.URL = this.$api.uplodFiles
            this.token = sessionStorage.getItem('authToken')
            this.userInfo = this.$store.state.userInfo
            var role = this.userInfo.roles
            for (var i = 0; i < role.length; i++) {
                //所有工厂数据
                if (role[i].factoryId == 0) {
                    this.ischeck = false
                    this.role = role[i]
                    this.isclear = true
                    break
                } else {
                    if (this.userInfo.factoryId == role[i].factoryId) {
                        this.role = role[i]
                    }
                }
            }
            this.getData()
            this.getFileTypeList()
        },
        methods: {
            fcChange: function() {
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                // this.getData()
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
                // this.getData()
            },
            sectionChange: function() {
                this.lineSelected = ''
                // this.getData()
            },
            lineChange: function() {
                // this.getData()
            },
            addDeviceFile() {
                this.fileForm = {}
                this.addDeviceFileShow = true
                this.fileUpload = true
                this.fileUrlShow = false
            },
            add(fileForm) {
                this.$refs[fileForm].validate((valid) => {
                    if (valid) {
                        let params = {
                            fileName: this.fileForm.fileName,
                            fileUrl: this.fileForm.fileUrl,
                            fileType: this.fileForm.fileType
                        }
                        this.deviceFileList.push(params)
                        console.log('this.deviceFileList', this.deviceFileList)
                        this.addDeviceFileShow = false
                    } else {
                        return false
                    }
                })
            },
            deleteDeviceFile(row) {
                this.deviceFileList.splice(row.$index, 1)
            },
            addDevice() {
                var self = this
                if (self.devCode == '' || self.devCode == null) {
                    self.$message.info('请输入设备编号')
                    return
                }
                if (self.devName == '' || self.devName == null) {
                    self.$message.info('请输入设备名')
                    return
                }
                if (self.devStatus == '' || self.devStatus == null) {
                    self.$message.info('请选择状态')
                    return
                }
                /*if(self.keyDevices == '' || self.keyDevices == null){
                    self.$message.info("请选择是否关键设备")
                    return;
                }*/
                if (self.personNo == '' || self.personNo == null) {
                    self.$message.info('请输入责任人工号')
                    return
                }
                if (self.person == '' || self.person == null) {
                    self.$message.info('请输入责任人')
                    return
                }
                if (self.yearOfManu == '' || self.yearOfManu == null) {
                    self.$message.info('请选择出厂年份')
                    return
                }
                if (self.dateOfArri == '' || self.dateOfArri == null) {
                    self.$message.info('请选择进厂日期')
                    return
                }
                if (self.serviceLife == '' || self.serviceLife == null) {
                    self.$message.info('请输入使用年限')
                    return
                }
                /*if(self.shopName == '' || self.shopName == null) {
                    self.$message.info("请输入车间名")
                    return;
                }
                if(self.sectionName == '' || self.sectionName == null) {
                    self.$message.info("请输入工段名")
                    return;
                }
                if(self.lineName == '' || self.lineName == null) {
                    self.$message.info("请输入产线名")
                    return;
                }*/
                if (self.fcIdSelected == '') {
                    self.$message.info('请选择所属工厂')
                    return
                }
                if (self.shopSelected == '') {
                    self.$message.info('请选择所属车间')
                    return
                }
                if (self.sectionSelected == '') {
                    self.$message.info('请选择所属工段')
                    return
                }
                if (self.lineSelected == '') {
                    self.$message.info('请选择所属产线')
                    return
                }
                /*if (self.devSupplier == '') {
                    self.$message.info('请输入供应商')
                    return
                }
                if (self.devSupConInf == '') {
                    self.$message.info('请输入供应商联系方式')
                    return
                }
                if (self.devSupplierAddress == '') {
                    self.$message.info('请输入供应商地址')
                    return
                }*/

                let params = {
                    devCode: self.devCode,
                    devName: self.devName,
                    fcCode: JSON.parse(self.fcIdSelected).deptCode,
                    fcName: JSON.parse(self.fcIdSelected).deptName,
                    shopCode: JSON.parse(self.shopSelected).deptCode,
                    shopName: JSON.parse(self.shopSelected).deptName,
                    sectionCode: JSON.parse(self.sectionSelected).deptCode,
                    sectionName: JSON.parse(self.sectionSelected).deptName,
                    lineCode: JSON.parse(self.lineSelected).deptCode,
                    lineName: JSON.parse(self.lineSelected).deptName,
                    fileList: self.deviceFileList,
                    note: self.note,
                    keyDevices: self.keyDevices,
                    person: self.person,
                    personNo: self.personNo,
                    yearOfManu: moment(self.yearOfManu).format('YYYY-MM-DD'),
                    dateOfArri: self.dateFormat(self.dateOfArri),
                    serviceLife: self.serviceLife,
                    devStatus: self.devStatus,
                    devSupplier: self.devSupplier,
                    devSupConInf: self.devSupConInf,
                    devSupplierAddress: self.devSupplierAddress,
                    assetsNo: self.assetsNo
                }
                let options = {
                    method: 'POST',
                    url: this.$api.addDevice,
                    data: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.$message.success('新增成功！！！')
                    } else {
                        self.$message.error(response.message)
                    }
                })
            },
            handleSuccess(res, file) {
                this.fileList = []
                this.fileForm.fileUrl = file.response.data
                this.fileUrlShow = true
                this.fileUpload = false
            },
            delImg() {

            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                    }
                })
            },
            getFileTypeList() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.enumTypelist,
                    params: {
                        enumType: 'dev_file'
                    }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.fileTypeList = response.data
                    }
                })
            },
            dateFormat(date) {
                return moment(date).format('YYYY-MM-DD HH:mm:ss')
            }
        }
    }
</script>

<style scoped>

</style>
